import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { _serverUrl2 } from "../../config";
import AdvTable from "../../Utils/AdvTable/AdvTable";

export default function ShowTable() {
  const history = useHistory();
  const states = useLocation().state;

  console.log(states);

  const [values, setValues] = useState([]);

  const getTableInfo = useCallback(async () => {
    await axios.post(_serverUrl2 + states.object.api, { filter: states.object.filter, selected: states.selected }).then((res) => {
      console.log(res.data.rows);
      setValues(res.data.rows);
    });
  }, [states.object.api, states.object.filter, states.selected]);

  useEffect(() => {
    getTableInfo();

    return () => {};
  }, [getTableInfo]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="textBox">
          <div className="content d-flex justify-content-between">
            <button className="orangeBtn" style={{ fontSize: "13px", width: "30px" }} onClick={() => history.goBack()}>
              <i className="fas fa-arrow-left"></i>
            </button>
            <b>{states.object.title}</b>
            <b>&nbsp;</b>
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="textBox">
          <div className="content" style={{ fontSize: "12px" }}>
            {states.object.type == "calisma" ? (
              <AdvTable
                columns={["Tip", "İsim Soyisim", "Düzenleme İçeriği", "Son Düzenleme"]}
                rows={values.map((d) => {
                  return [
                    { type: "str", key: "dosya_adi", label: d.calisma_tip, value: d.calisma_tip },
                    { type: "str", key: "tasinmaz_adi", label: d.isim_soyisim, value: d.isim_soyisim },
                    { type: "str", key: "adres", label: d.duzenleme_icerigi, value: d.duzenleme_icerigi },
                    { type: "str", key: "kiralanan_kurum", label: d.duzenleme_tarihi, value: d.duzenleme_tarihi },
                  ];
                })}
              />
            ) : states.object.type == "numarataj" ? (
              <AdvTable
                columns={["Adres", "Kapı No", "İşlem Durum", "Açıklama", "Kontrol Durum"]}
                rows={values.map((d) => {
                  return [
                    { type: "str", key: "dosya_adi", label: d.adres, value: d.adres },
                    { type: "str", key: "tasinmaz_adi", label: d.kapi_no, value: d.kapi_no },
                    { type: "str", key: "adres", label: d.islem_durum, value: d.islem_durum },
                    { type: "str", key: "kiralanan_kurum", label: d.aciklama, value: d.aciklama },
                    { type: "str", key: "dosya_adi", label: d.kontrol_durum, value: d.kontrol_durum },
                    { type: "id", key: "id", value: d.id },
                    states.object.title != "Numarataj İlçelere Göre " && { type: "geom", key: "geom", value: d.geojson },
                  ];
                })}
                routePath="/dashboard/hsign/update/"
              />
            ) : (
              <AdvTable
                columns={["Adres", "Kapı No", "İşlem Durum", "Açıklama", "Kontrol Durum"]}
                rows={values.map((d) => {
                  return [
                    { type: "str", key: "adres", label: d.adres, value: d.adres },
                    { type: "str", key: "tip", label: d.tip, value: d.tip },
                    { type: "str", key: "islem_durum", label: d.islem_durum, value: d.islem_durum },
                    { type: "str", key: "aciklama", label: d.aciklama, value: d.aciklama },
                    { type: "str", key: "kontrol_durum", label: d.kontrol_durum, value: d.kontrol_durum },
                    { type: "id", key: "id", value: d.id },
                    states.object.title != "Direk/Duvar İlçelere Göre " && { type: "geom", key: "geom", value: d.geojson },
                  ];
                })}
                routePath="/dashboard/sign/update/"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
